module.exports = __webpack_public_path__ + "static/media/ic_keyboard_arrow_up_black_36px.e1ba586b.svg";